"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var md_1 = require("react-icons/md");
var DeltaIcon = function (_a) {
    var value = _a.value;
    if (value < 0) {
        return react_1.default.createElement(md_1.MdArrowDownward, { viewBox: "0 0 24 18" });
    }
    else if (value > 0) {
        return react_1.default.createElement(md_1.MdArrowUpward, { viewBox: "0 0 24 18" });
    }
    else {
        return react_1.default.createElement("span", null, "\u00A0\u00A0\u00A0\u00A0");
    }
};
exports.default = DeltaIcon;
